// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { NotificationsSubscriptions } from '../../../../types/server/modules/notifications/subscriptions';

export type * from '../../../../types/server/modules/notifications/subscriptions';

export const createSubscriptions = ( requests: Requests ): NotificationsSubscriptions => ({
  Notifications: ( params, onChange ) => {
          return requests.subscribe( `/notifications/:id?`, params, 'Notifications', onChange );
          }
});
